module.exports = __webpack_public_path__ + "static/media/jessicaStaheli.01b2c5cf.jpg";